// extracted by mini-css-extract-plugin
export default {"collapsible":"BMh0zTcySJ4tmQMG0Ctm","open":"qg2FAcOuouWuLozpOBfF","collapsibleInner":"MhXc6BjWlAL0AzTerWjH"};